

import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, CardTitle, FormGroup, Input, Table, Row, Col } from "reactstrap";
import useToken from "../../helpers/useToken"
import useTimeZone from "../../helpers/useTimeZone"
import PaginationCustom from "../PaginationCustom/PaginationCustom"
import TMHLoader from "../TMHLoader/TMHLoader"
import { parseCustomTime } from "../../helpers/utils";

export default function NotificationUserTable({ notificationConfig }) {
    const [users, setUsers] = useState()
    const { token } = useToken()
    const { timeZone } = useTimeZone()
    const [isLoading, setIsLoading] = useState(false)
    const [pager, setPager] = useState({
        size: 10,
        offset: 0,
        text: ''
    });

    const [totalUser, setTotalUser] = React.useState(5000);

    useEffect(() => {
        const initData = async () => {
            if (!notificationConfig) { return }
            console.log('NotificationUserTable: update data')
            setIsLoading(true)
            var myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);
            myHeaders.append("Content-Type", "application/json");

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify(notificationConfig)
            }

            var params = new URLSearchParams({
                'page_size': pager.size,
                'offset': pager.offset,
                'search_text': pager.text
            })


            fetch(process.env.REACT_APP_BASE_URL + "notification/qualifying_users?" + params, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        var json = result.json
                        if (result.ok) {
                            setUsers(json.data)
                            setTotalUser(json.page_dto.total)
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json.message)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [notificationConfig, pager, setIsLoading, token])

    return (
        <TMHLoader active={isLoading}>
            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <Row>
                                <Col md="8">
                                    {
                                        notificationConfig && <CardTitle tag="h2">
                                            Qualifying Users ({totalUser}) - {notificationConfig.description}
                                        </CardTitle>
                                    }
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md="4" className="pt-2">
                                    <CardTitle tag="h5">Shows {" "}
                                        <select
                                            value={pager?.size}
                                            onChange={(e) => setPager({
                                                size: e.target.value,
                                                text: pager.text,
                                                offset: 0,
                                                method: pager.method
                                            })}>

                                            <option>10</option>
                                            <option>25</option>
                                            <option>50</option>
                                            <option>100</option>
                                        </select> entries
                                    </CardTitle>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label>Search</label>
                                        <Input
                                            placeholder="Search User Name, User ID, PIN, Device ID, Mobile Id"
                                            type="text"
                                            onChange={(e) => {
                                                let text = e.target.value
                                                if (text.length > 3 || text.length === 0) {
                                                    setPager({
                                                        size: pager.size,
                                                        offset: 0,
                                                        text: text,
                                                        method: pager.method
                                                    })
                                                }
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Table striped className="tablesorter">
                                <thead className="text-primary">
                                    <tr>
                                        <th>Sign up</th>
                                        <th>Email</th>
                                        <th>Pin</th>
                                        <th>Mobile ID</th>
                                        <th>Roku ID</th>
                                        <th>Channel ID</th>
                                        <th>TMH</th>
                                        <th>Last Connect Roku</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        users?.map((userData) => {
                                            return (
                                                <tr key={userData.id}>
                                                    <td>{parseCustomTime(userData.created_at, timeZone)}</td>
                                                    <td>{userData.email}</td>
                                                    <td>{userData.pin}</td>
                                                    <td>{userData.mobile_device_id}</td>
                                                    <td>{userData.roku_device_id}</td>
                                                    <td>{userData.device_id && userData.device_id.split("-")[0]}</td>
                                                    <td>{userData.mobile_device_id && userData.device_id && "YES"}</td>
                                                    <td>{userData.last_active && (userData.last_active + " minutes ago")}</td>
                                                </tr>)
                                        })
                                    }
                                </tbody>
                            </Table>
                            <PaginationCustom pager={pager} total={totalUser} setPager={setPager} />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </TMHLoader>


    )
}